import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "header",
  class: "fixed w-full z-30 top-0 text-white"
}
const _hoisted_2 = { class: "container mx-auto flex flex-wrap items-center justify-between mt-2 py-2 border-gray-100 rounded-full border-2 drop-shadow bg-white" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "pl-4 flex items-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "toggleColour text-white no-underline hover:no-underline font-bold text-2xl lg:text-4xl",
    href: "#"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "y-2 mt-2 ml-2 md:w-40 z-50 w-40",
      src: "assets/icon/logo_iduit.png",
      alt: ""
    })
  ])
], -1)
const _hoisted_4 = { class: "block lg:hidden pr-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  class: "fill-current h-6 w-6",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "Menu"),
  /*#__PURE__*/_createElementVNode("path", { d: "M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" })
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<ul class=\"list-reset lg:flex justify-end flex-1 items-center\"><li class=\"mr-3\"><a class=\"inline-block uppercase py-2 px-4 font-medium no-underline text-orange-400 active:text-orange-500\" href=\"/\">Inicio</a></li><li class=\"mr-3\"><a class=\"inline-block uppercase no-underline font-medium hover:text-orange-500 hover:text-underline py-2 px-4\" href=\"/nosotros\">Nosotros</a></li><li class=\"mr-3\"><a class=\"inline-block uppercase no-underline font-medium hover:text-orange-500 hover:text-underline py-2 px-4\" href=\"/especialistas\">Especialistas</a></li><li class=\"mr-3\"><a class=\"inline-block uppercase no-underline font-medium hover:text-orange-500 hover:text-underline py-2 px-4\" href=\"/contacto\">Contactanos</a></li></ul>", 1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.mobileSidebar = !_ctx.mobileSidebar)),
          id: "nav-toggle",
          class: "flex items-center p-1 text-orange-400 hover:text-orange-600 focus:outline-none focus:shadow-outline transform transition hover:scale-105 duration-300 ease-in-out"
        }, _hoisted_6)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.mobileSidebar ? '' : 'hidden', "w-full flex-grow lg:flex lg:items-center lg:w-auto mt-2 lg:mt-0 bg-white lg:bg-transparent text-black p-4 lg:p-0 z-20"]),
        id: "nav-content"
      }, _hoisted_8, 2)
    ])
  ]))
}